export default function generateRoute(route, parameterValue = '', placeholder = '?') {
    return generateRouteWithMultipleParameters(route, { [placeholder]: parameterValue });
}

export function generateRouteWithMultipleParameters(route, parameters = {}) {
    if (!route) {
        return;
    }

    let newRoute = route;

    for (let key in parameters) {
        newRoute = newRoute?.replace(key, parameters[key]);
    }

    return newRoute;
}
